<app-topnav [pageName]="pageName"></app-topnav>
<div class="container">
  <div class="content user-mgmt-page" role="main">
    <header class="user-mgmt-page__header">
      <div>
        <h1 class="user-mgmt-page__title">Tags</h1>
        <p class="user-mgmt-page__subtitle">Search, filter, and manage course tags and categories.</p>
        @if (totalRecords > 0) {
          <div class="user-mgmt-page__meta">
            <span class="user-mgmt-page__count">{{ totalRecords | number }} tags found</span>
          </div>
        }
      </div>
      <div class="user-mgmt-page__actions">
        @if (showAddButton) {
          <a routerLink="/create-tag" class="user-mgmt-page__btn user-mgmt-page__btn--primary">
            <mat-icon>add</mat-icon>
            Add Tag
          </a>
        }
      </div>
    </header>

    <section class="user-mgmt-page__filters">
      <form (ngSubmit)="search()">
        <div class="user-mgmt-page__filters-grid">
          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Search</mat-label>
            <mat-icon matPrefix>search</mat-icon>
            <input matInput class="form-control-textbox" name="filterSearch" [(ngModel)]="queryFilter.TagKeyword" placeholder="Tag name" />
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Category</mat-label>
            <mat-select placeholder="All Categories" name="filterFacilityHealthRegion" [(ngModel)]="queryFilter.TagCategoryId">
              <mat-option value="0">All Categories</mat-option>
              @for (tc of tagCategory; track tc) {
                <mat-option [value]="tc.id">{{ tc.categoryName }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always">
            <mat-label>Status</mat-label>
            <mat-select placeholder="All Statuses" name="filterStatus" [(ngModel)]="queryFilter.Status">
              <mat-option value="ALL">All Statuses</mat-option>
              <mat-option value="ACTIVE">Active</mat-option>
              <mat-option value="INACTIVE">Inactive</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="user-mgmt-page__filters-actions">
          <button class="user-mgmt-page__btn user-mgmt-page__btn--primary" type="submit" #submitButton>
            <mat-icon>filter_list</mat-icon>
            Apply Filters
          </button>
          <button class="user-mgmt-page__btn user-mgmt-page__btn--secondary" type="button" (click)="resetFilters()">
            <mat-icon>restart_alt</mat-icon>
            Reset
          </button>
        </div>
      </form>
    </section>

    <section class="user-mgmt-page__table-card">
      <ng-container *ngTemplateOutlet="tagTable; context: { data: tags, headerVisible: true }"></ng-container>
      <mat-paginator
        #paginator
        [length]="totalRecords"
        [pageSize]="25"
        [hidden]="totalRecords === 0"
        [pageSizeOptions]="[10, 25, 50]"
        (page)="handlePageEvent($event)"
        aria-label="Tag list pagination">
      </mat-paginator>
    </section>
  </div>
</div>

<ng-template #tagTable let-data="data" let-headerVisible="headerVisible">
  <app-no-results #noResults></app-no-results>

  <table mat-table class="fileList primary" [dataSource]="data" [hidden]="data.length === 0">
    <ng-container matColumnDef="Tag">
      <th mat-header-cell *matHeaderCellDef>Tags</th>
      <td mat-cell *matCellDef="let tag">
        <a [routerLink]="['/view-tag', tag.id]" class="user-mgmt-page__user-link">{{ tag.tagName }}</a>
      </td>
    </ng-container>

    <ng-container matColumnDef="Category">
      <th mat-header-cell *matHeaderCellDef>Categories</th>
      <td mat-cell *matCellDef="let tag">
        @if (tag.tagsCategories?.length) {
          <ul class="user-mgmt-page__chip-list">
            @for (category of tag.tagsCategories; track category) {
              <li>
                <span class="user-mgmt-page__chip">{{ category }}</span>
              </li>
            }
          </ul>
        } @else {
          <span class="user-mgmt-page__empty-text">—</span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="Status">
      <th mat-header-cell *matHeaderCellDef>
        Status
        <app-information-popup [information]="information"></app-information-popup>
      </th>
      <td mat-cell *matCellDef="let tag">
        <app-status-bubble [status]="tag.status"></app-status-bubble>
      </td>
    </ng-container>

    @if (headerVisible) {
      <tr mat-header-row *matHeaderRowDef="columnsToDisplay" class="tableHeader"></tr>
    }
    <tr mat-row *matRowDef="let row; columns: columnsToDisplay"></tr>
  </table>
</ng-template>

<app-footer></app-footer>
